import React from 'react'

const Errorpage = () => {
  return (
    <div className='flex justify-center'>
      <h1 className='text-red-600'>
        Some Inteal Server Error
      </h1>
    </div>
  )
}

export default Errorpage
